module.exports = __webpack_public_path__ + "static/img/tb000.328499b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tools/wodistant/tb000.png
// module id = Qo+N
// module chunks = 1